/**
 * Shared helpers for sprint trash operations.
 */

export const isTemplateItem = (item) => item?.isTemplate === true || item?.type === 'template';

const THIRTY_DAYS_IN_SECONDS = 30 * 24 * 60 * 60;

export function computeExpiresAt() {
  return Math.floor(Date.now() / 1000) + THIRTY_DAYS_IN_SECONDS;
}

/** Recursively find all nested children of a sprint. */
export function findNestedChildren(sprints, parentId) {
  const children = [];
  const walk = (pid) => {
    sprints.forEach((s) => {
      if (s.parentSprintId === pid) {
        children.push(s);
        walk(s.id);
      }
    });
  };
  walk(parentId);
  return children;
}

export function snapshotByIds(sprints, ids) {
  const idSet = ids instanceof Set ? ids : new Set(ids);
  return new Map(
    sprints.filter((s) => idSet.has(s.id)).map((s) => [s.id, s])
  );
}

export function revertFromSnapshots(setSprints, snapshots) {
  setSprints((prev) => prev.map((s) => snapshots.get(s.id) || s));
}

export function stripUndefinedFields(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === undefined) {
      delete obj[key];
    }
  });
  return obj;
}

export function clearTrashFields(item) {
  const next = { ...item };
  delete next.deletedAt;
  delete next.expiresAt;
  delete next._trashedViaAncestorId;
  return next;
}

export function logAudit(event, payload, sprintId) {
  if (window.pletAudit) {
    window.pletAudit.log(event, payload, sprintId);
  }
}

export function clearSelectionIfNeeded({
  affectedIds,
  selectedSprintId,
  selectedTemplateId,
  setSelectedSprintId,
  setSelectedTemplateId,
  setCurrentView,
  VIEWS,
}) {
  const idSet = affectedIds instanceof Set ? affectedIds : new Set(affectedIds);
  if (idSet.has(selectedSprintId)) {
    setSelectedSprintId(null);
    setCurrentView(VIEWS.EMPTY);
  }
  if (idSet.has(selectedTemplateId)) {
    setSelectedTemplateId(null);
    setCurrentView(VIEWS.EMPTY);
  }
}
